export const countryCodes = [
    // 🌏 Southeast Asia (priority for you)
    { label: '+855', value: '+855', flag: '🇰🇭', name: 'Cambodia' },
    { label: '+66', value: '+66', flag: '🇹🇭', name: 'Thailand' },
    { label: '+84', value: '+84', flag: '🇻🇳', name: 'Vietnam' },
    { label: '+856', value: '+856', flag: '🇱🇦', name: 'Laos' },
    { label: '+95', value: '+95', flag: '🇲🇲', name: 'Myanmar' },
    { label: '+60', value: '+60', flag: '🇲🇾', name: 'Malaysia' },
    { label: '+65', value: '+65', flag: '🇸🇬', name: 'Singapore' },
    { label: '+62', value: '+62', flag: '🇮🇩', name: 'Indonesia' },
    { label: '+63', value: '+63', flag: '🇵🇭', name: 'Philippines' },
    { label: '+673', value: '+673', flag: '🇧🇳', name: 'Brunei' },

    // 🌏 East Asia
    { label: '+86', value: '+86', flag: '🇨🇳', name: 'China' },
    { label: '+852', value: '+852', flag: '🇭🇰', name: 'Hong Kong' },
    { label: '+853', value: '+853', flag: '🇲🇴', name: 'Macau' },
    { label: '+886', value: '+886', flag: '🇹🇼', name: 'Taiwan' },
    { label: '+81', value: '+81', flag: '🇯🇵', name: 'Japan' },
    { label: '+82', value: '+82', flag: '🇰🇷', name: 'South Korea' },

    // 🌍 South Asia
    { label: '+91', value: '+91', flag: '🇮🇳', name: 'India' },
    { label: '+880', value: '+880', flag: '🇧🇩', name: 'Bangladesh' },
    { label: '+94', value: '+94', flag: '🇱🇰', name: 'Sri Lanka' },
    { label: '+92', value: '+92', flag: '🇵🇰', name: 'Pakistan' },

    // 🌍 Middle East
    { label: '+971', value: '+971', flag: '🇦🇪', name: 'UAE' },
    { label: '+966', value: '+966', flag: '🇸🇦', name: 'Saudi Arabia' },
    { label: '+974', value: '+974', flag: '🇶🇦', name: 'Qatar' },
    { label: '+965', value: '+965', flag: '🇰🇼', name: 'Kuwait' },
    { label: '+20', value: '+20', flag: '🇪🇬', name: 'Egypt' },

    // 🌍 Europe
    { label: '+44', value: '+44', flag: '🇬🇧', name: 'UK' },
    { label: '+33', value: '+33', flag: '🇫🇷', name: 'France' },
    { label: '+49', value: '+49', flag: '🇩🇪', name: 'Germany' },
    { label: '+39', value: '+39', flag: '🇮🇹', name: 'Italy' },
    { label: '+34', value: '+34', flag: '🇪🇸', name: 'Spain' },
    { label: '+31', value: '+31', flag: '🇳🇱', name: 'Netherlands' },
    { label: '+41', value: '+41', flag: '🇨🇭', name: 'Switzerland' },
    { label: '+46', value: '+46', flag: '🇸🇪', name: 'Sweden' },

    // 🌎 Americas
    { label: '+1', value: '+1', flag: '🇺🇸', name: 'USA / Canada' },
    { label: '+52', value: '+52', flag: '🇲🇽', name: 'Mexico' },
    { label: '+55', value: '+55', flag: '🇧🇷', name: 'Brazil' },
    { label: '+54', value: '+54', flag: '🇦🇷', name: 'Argentina' },
    { label: '+56', value: '+56', flag: '🇨🇱', name: 'Chile' },

    // 🌏 Oceania
    { label: '+61', value: '+61', flag: '🇦🇺', name: 'Australia' },
    { label: '+64', value: '+64', flag: '🇳🇿', name: 'New Zealand' },
];